import { render, staticRenderFns } from "./FPPSalesDashboardFilterMetrics.vue?vue&type=template&id=04c8ad9a&scoped=true&"
import script from "./FPPSalesDashboardFilterMetrics.vue?vue&type=script&lang=ts&"
export * from "./FPPSalesDashboardFilterMetrics.vue?vue&type=script&lang=ts&"
import style0 from "./FPPSalesDashboardFilterMetrics.vue?vue&type=style&index=0&id=04c8ad9a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c8ad9a",
  null
  
)

export default component.exports